import { Alert } from 'react-bootstrap';

import { ApiError } from '../../../api';

export const ServerErrorsAlert = ({
  errors,
  showErrors,
  className = 'my-5',
  clearErrors,
}: {
  errors?: ApiError;
  showErrors: boolean;
  className?: string;
  clearErrors?: () => void;
}) => {
  return (
    <Alert
      dismissible={clearErrors ? true : false}
      show={showErrors}
      variant="danger"
      className={className}
      onClose={() => {
        if (clearErrors) clearErrors();
      }}
    >
      <Alert.Heading>Something Went Wrong</Alert.Heading>
      {errors?.body?.non_field_errors && (
        <ul>
          {errors?.body?.non_field_errors?.map((error) => (
            <li key={error}>{error}</li>
          ))}
        </ul>
      )}
      {errors?.body?.error && <p>{errors?.body?.error}</p>}
      {errors?.body?.message && <p>{errors?.body?.message}</p>}
    </Alert>
  );
};
